import { ChatDetail } from "./ChatAction";
import { ChatState } from "./ChatState";
import { createDefaultState } from "./DefaultState";

export function createStateFromMessages(messages: readonly ChatDetail[]): ChatState {
    const def = createDefaultState();

    // Extract chips from the last message's options (matching rootReducer behavior)
    const lastMessage = messages.length > 0 ? messages[messages.length - 1] : undefined;
    const lastMsg = lastMessage?.type === "chat.msg" ? lastMessage.msg : null;
    const chips = lastMsg?.options?.length ? lastMsg.options : [];

    return {
        ...def,
        connection: {
            ...def.connection,
            connectionStatus: "online"
        },
        accountStatus: "online",
        chats: [...messages],
        chips,
        isChatting: true,
        visuals: {
            visible: true,
            opened: true,
        }
    };
}
